import { useRef } from 'react'

export function useFadeIn() {
  const ref = useRef<HTMLDivElement>(null)
  return { ref, className: '' }
}
